import type { CountryCode } from '../PhonePrefix'
import phonePrefixes from './../phonePrefixes.json' assert { type: 'json' }

export const findCountryInfoByDescriptionAndPrefix = (
	description: string,
	prefix: string
): CountryCode | undefined => {
	const { countryCodes } = phonePrefixes

	return countryCodes.find(
		(country) =>
			country.countryDescription === description &&
			country.phonePrefix === prefix
	)
}
